import createIcon from '../../createIcon';

/**
 * @component @name PhotoAlbum
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTggMkg2QzQuOSAyIDQgMi45IDQgNFYyMEM0IDIxLjEgNC45IDIyIDYgMjJIMThDMTkuMSAyMiAyMCAyMS4xIDIwIDIwVjRDMjAgMi45IDE5LjEgMiAxOCAyWk0xMSA0SDE2VjExTDEzLjUgOS41TDExIDExVjRaTTcgMThMOS4zOCAxNC44M0wxMSAxN0wxMy42MiAxMy41TDE3IDE4SDdaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PhotoAlbum = createIcon('PhotoAlbum', [
  [
    'path',
    {
      d: 'M18 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V4C20 2.9 19.1 2 18 2ZM11 4H16V11L13.5 9.5L11 11V4ZM7 18L9.38 14.83L11 17L13.62 13.5L17 18H7Z',
      key: '7f19bx',
    },
  ],
]);

export default PhotoAlbum;
